import { environment } from '#environments';
import { FunctionalReviewResponse, FunctionalReview, FunctionalReviewCreate, Item } from '#models';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, share, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FunctionalReviewService {
  _httpClient = inject(HttpClient);

  getFunctionalReview(
    mocId: number,
    checklistId: number,
    frChecklistRecordId: number
  ): Observable<FunctionalReview | null> {
    const result = this._httpClient
      .get<FunctionalReview>(
        `${environment.apiUrl}/functionalreviews?mocId=${mocId}&checklistId=${checklistId}&frChecklistRecordId=${frChecklistRecordId}`
      )
      .pipe(
        share(),
        catchError(err => {
          if (err instanceof HttpErrorResponse && err.status === 404) {
            return of(null);
          }

          return throwError(() => err);
        })
      );

    return result;
  }

  createFunctionalReview(payload: FunctionalReviewCreate): Observable<FunctionalReview> {
    return this._httpClient.post<FunctionalReview>(`${environment.apiUrl}/functionalreviews`, payload);
  }

  createResponse(response: FunctionalReviewResponse): Observable<FunctionalReviewResponse | null> {
    return this._httpClient.post<FunctionalReviewResponse>(`${environment.apiUrl}/responses`, response);
  }

  deleteResponse(item: Item): Observable<FunctionalReviewResponse | null> {
    return this._httpClient.delete<FunctionalReviewResponse>(`${environment.apiUrl}/responses/` + item.id);
  }

  updateResponse(item: Pick<Item, 'id' | 'answerId'>): Observable<FunctionalReviewResponse | null> {
    const payload = { id: item.id, answerId: item.answerId };

    return this._httpClient.put<FunctionalReviewResponse>(`${environment.apiUrl}/responses/${item.id}/answer`, payload);
  }

  getReport(reviewId: number): Observable<Blob> {
    return this._httpClient.get<Blob>(`${environment.apiUrl}/functionalreviews/${reviewId}/report`, {
      responseType: 'blob' as 'json',
    });
  }

  completeReview(reviewId: number): Observable<FunctionalReview | null> {
    const result = this._httpClient
      .put<FunctionalReview>(`${environment.apiUrl}/functionalreviews/${reviewId}/complete`, {})
      .pipe(
        share(),
        catchError(err => {
          if (err instanceof HttpErrorResponse && err.status === 404) {
            return of(null);
          }

          return throwError(() => err);
        })
      );

    return result;
  }
}
